/** @ngInject */
export function Controller(
    $state,
    $timeout,
) {
    this.$onInit = () => {

        var initIntegrationOverviewTab = function(){
            $('#federateSsoLink').click(function(event) {
                event.preventDefault();
                $state.go('^.configure-sso');
            });
            $('#manualConfigurationLink').click(function(event) {
                event.preventDefault();
                $state.go('^.manual-integration');
            });
            $('.userProvisioningLink').click(function(event) {
                event.preventDefault();
                $state.go('^.^.user-provisioning');
            });            
            $('#userAccountsLink').click(function(event) {
                event.preventDefault();
                $state.go('^.^.users');
            });      
            $('#goToConfiguration').click(event => {
                event.preventDefault();
                $state.go('company.manage-application.configuration');
            });
        };
        
        $timeout( function(){ 
            initIntegrationOverviewTab();     
        }, 200);
    };
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/integration-developers/integration-office-365/integration-office-365.controller.js